import './App.css';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SplashScreen from './components/SplashScreen/SplashScreen';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import WhyUs from './components/WhyUs/WhyUs';
import Services from './components/Services/Services';
import Collaboration from './components/Collaboration/Collaboration';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

// Import faqet e reja
import TaxAccounting from './pages/TaxAccounting';
import InternalAuditing from './pages/InternalAuditing';
import FinancialConsulting from './pages/FinancialConsulting';
import FinancialManagement from './pages/FinancialManagement';
import BusinessAnalysis from './pages/BusinessAnalysis';
import AboutCompany from './pages/AboutCompany';
import Team from './pages/Team';
import Career from './pages/Career';
import Blog from './pages/Blog';
import FAQ from './pages/FAQ';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

function HomePage() {
  return (
    <div className="main-bg">
      <Header />
      <Hero />
      <WhyUs />
      <About /> 
      <Services />
      <Collaboration />
      <Contact />
      <Footer />
    </div>
  );
}

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    // Për testim - fshi localStorage nëse ka parametrin ?reset=true
    const shouldReset = new URLSearchParams(window.location.search).get('reset') === 'true';
    if (shouldReset) {
      localStorage.removeItem('hasVisitedShalaAccounting');
    }
  }, []);

  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  if (showSplash) {
    return <SplashScreen onComplete={handleSplashComplete} />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        
        {/* Faqet e shërbimeve */}
        <Route path="/services/tax-accounting" element={<TaxAccounting />} />
        <Route path="/services/internal-auditing" element={<InternalAuditing />} />
        <Route path="/services/financial-consulting" element={<FinancialConsulting />} />
        <Route path="/services/financial-management" element={<FinancialManagement />} />
        <Route path="/services/business-analysis" element={<BusinessAnalysis />} />
        
        {/* Faqet e About Us */}
        <Route path="/about/company" element={<AboutCompany />} />
        <Route path="/about/team" element={<Team />} />
        <Route path="/about/career" element={<Career />} />
        
        {/* Faqet e Burime */}
        <Route path="/resources/faq" element={<FAQ />} />
        <Route path="/resources/blog" element={<Blog />} />
        <Route path="/resources/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/resources/terms-of-service" element={<TermsOfService />} />
      </Routes>
    </Router>
  );
}

export default App;
